import GfcrCallout from './GfcrCallout'

export default GfcrCallout
